/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.full-page-background{background-image:url(assets/background.59fc83e26c663ade5dcae6e7d56ca970.jpg)}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvdGhlbWUvY3NzL2F1dGguY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi90aGVtZS9jc3MvYXV0aC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./compiled/theme/css/auth.css.ngstyle.ts